module.exports = __webpack_public_path__ + "03_medium_brown.e1735e3b.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/dad/layer5/03_medium_brown.png
// module id = Mvou
// module chunks = 0